import { render } from "./ModuleContainer.vue?vue&type=template&id=215653dc&ts=true"
import script from "./ModuleContainer.vue?vue&type=script&lang=ts"
export * from "./ModuleContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__